import { BrowserRouter } from 'react-router-dom'
import AppContainer from './components/AppContainer/AppContainer'
import { FilterProvider } from './contexts/FilterContext'

const App = () => {
  return (
    <BrowserRouter>
      <div className="App">
        <FilterProvider>
          <AppContainer />
        </FilterProvider>
      </div>
    </BrowserRouter>
  )
}

export default App
